import { Component } from './component';

export interface ButtonProps {
  text: string;
  onClick?: () => void;
  type?: 'submit' | 'reset' | 'button';
  default?: boolean;
  disabled?: boolean;
}

export class Button extends Component {
  public el: HTMLElement;

  constructor(props: ButtonProps) {
    super();
    this.el = document.createElement('button');
    this.el.textContent = props.text;
    this.el.addEventListener('click', () => {
      if (props.onClick) {
        props.onClick();
      }
    });
    this.el.setAttribute('type', props.type ?? 'button');
    if (props.default) {
      this.el.classList.add('default');
    }
    if (props.disabled) {
      this.el.setAttribute('disabled', 'disabled');
    }
  }

  disable() {
    this.el.setAttribute('disabled', 'disabled');
  }

  enable() {
    this.el.removeAttribute('disabled');
  }
}
